import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { TherapeuticArea } from '~/Api/Analytics/Autocomplete/TherapeuticArea';
import { ThunkDispatch } from '~/Store';
import Autocomplete, { Option } from '~/UI/Autocomplete/Autocomplete';

import { loadTherapeuticAreas } from './actions';
import { selectTherapeuticAreas, State as TherapeuticAreasState } from './reducer';

interface State {
	medicinalBrandsAnalyticsTherapeuticAreaAutocomplete: TherapeuticAreasState;
}

interface OwnProps {
	value?: string;
	selectedIds?: string[] | string;
	onChange?: (value: string) => void;
}

const mapOptions = memoizeOne((therapeuticAreas: TherapeuticArea[]): Option[] => {
	return therapeuticAreas.map((therapeuticArea) => ({
		id: therapeuticArea.name,
		title: therapeuticArea.name,
	}));
});

const filterOptions = memoizeOne((options: Option[], query: string): Option[] => {
	const lowerCasedQuery = query.toLowerCase();
	const filteredOptions = options.filter((option) => option.title.toLowerCase().includes(lowerCasedQuery));
	filteredOptions.sort((a, b) => a.title.localeCompare(b.title));
	return filteredOptions;
});

const mapSelectedOptions = memoizeOne((selectedNames: string[]): Option[] => {
	return selectedNames.map((name) => ({ id: name, title: name }));
});

function mapStateToProps(
	{ medicinalBrandsAnalyticsTherapeuticAreaAutocomplete }: State,
	{ value, selectedIds }: OwnProps
): {
	options: Option[];
	selectedOptions: Option[];
} {
	const therapeuticAreas =
		selectTherapeuticAreas(medicinalBrandsAnalyticsTherapeuticAreaAutocomplete, value || '')?.items || [];
	const options = mapOptions(therapeuticAreas);

	const truthySelectedIds = selectedIds || [];
	const normalizedSelectedIds = Array.isArray(truthySelectedIds) ? truthySelectedIds : [truthySelectedIds];

	return {
		options: filterOptions(options, value || ''),
		selectedOptions: mapSelectedOptions(normalizedSelectedIds),
	};
}

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	{ onChange }: OwnProps
): {
	onChange(value: string): void;
} {
	return {
		onChange: (value: string) => {
			onChange?.(value);
			if (value !== '') {
				dispatch(loadTherapeuticAreas(value));
			}
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Autocomplete);
